import { Alert } from '@mui/material';
import { styled } from '@mui/material/styles';

export const AlertStyled = styled(Alert)({
  alignItems: 'center',
  '& .MuiAlert-icon': {
    padding: 0,
  },
  '& .MuiAlert-message': {
    padding: '8 0 px',
    flex: 1,
  },
  '& .MuiAlert-action': {
    paddingTop: 0,
    gap: '16px',
  },
});
